import { CheckmarkIcon } from '@navikt/aksel-icons';
import { Paragraph } from '@digdir/designsystemet-react';

import styled from '../../../../styled';

interface CompletedProps {
  $isCompleted?: boolean;
}

interface ActiveProps {
  $isActive?: boolean;
}

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 227px;
  // Same as ::after height in Dot
  gap: var(--ds-size-4);
  position: sticky;
  top: calc(var(--header-height) + var(--ds-size-8));
`;

export const Step = styled.div`
  display: flex;
  align-items: center;
  gap: var(--ds-size-6);
`;

export const Dot = styled.div<CompletedProps & ActiveProps>`
  width: var(--ds-size-8);
  height: var(--ds-size-8);
  border-radius: var(--ds-border-radius-default);
  border: 1px solid var(--ds-color-border-subtle);

  display: flex;
  justify-content: center;
  align-items: baseline;
  position: relative;

  color: var(--ds-color-text-subtle);
  font-weight: 600;
  line-height: 130%;

  ${({ $isCompleted }) =>
    $isCompleted &&
    `
    background-color: var(--ds-color-base-default);
    border-color: var(--ds-color-base-default);
    color: var(--ds-color-base-contrast-subtle);
    align-items: center;
  `}

  ${({ $isActive }) =>
    $isActive &&
    `
    border-color: var(--ds-color-base-default);
    background-color: var(--ds-color-surface-tinted);
  `}

  ::after {
    content: '';
    display: block;
    position: absolute;
    // Compensate for border
    top: calc(100% + 1px);
    left: 50%;
    border-left: 1px solid var(--ds-color-border-subtle);
    // Same as gap between steps
    height: var(--ds-size-4);
  }

  ${Step}:last-child &::after {
    display: none;
  }
`;

export const StepLabel = styled(Paragraph)<ActiveProps>`
  ${({ $isActive }) =>
    $isActive &&
    `
    font-weight: var(--ds-font-weight-medium);
  `}
`;

export const StyledCheckmarkIcon = styled(CheckmarkIcon)`
  height: 20px;
  width: 20px;
`;
